import React from "react"
import { useDispatch } from "react-redux"
import { Form, Button } from "antd"
import { CustomForm } from "ui/Form"
import { Modal } from "ui/Modal"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { TextArea } from "ui/Input"
import PropTypes from "prop-types"
import { suggestMarketplaceTag } from "store/trips"
import { toaster } from "components/common/Toast"

export const RequestMarketplaceTagModal = ({ isVisible, onCancel }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      dispatch(suggestMarketplaceTag({ name: values.message })).then((result) => {
        toaster.success({ title: result?.success })
        form.resetFields()
        onCancel()
      })
    })
  }

  const handleCancel = () => {
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      title={t("experiences.details.request_tag")}
      open={isVisible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel} size="large">
          {t("global.cancel")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit} size="large">
          {t("global.send_request")}
        </Button>
      ]}
      center
    >
      <CustomForm form={form} layout="vertical">
        <Text className="block" variant="body">
          {t("experiences.details.category_modal.info")}
        </Text>
        <Form.Item
          name="message"
          label={t("experiences.details.category_modal.option_suggestion")}
          rules={[{ required: true, message: t("experiences.details.category_modal.suggestion_error") }]}
          className="mt-xl"
        >
          <TextArea placeholder={t("experiences.details.category_modal.option_suggestion_placeholder")} rows={4} autoFocus />
        </Form.Item>
      </CustomForm>
    </Modal>
  )
}

RequestMarketplaceTagModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
}
